import React, { useEffect } from "react";
import CommonNav from "../main/CommonNav2";
import LogiTalkLandingCarousel from "./compnent/LogiTalkLandingCarousel";
import LogiTalkLandingProductInfo from "./compnent/LogiTalkLandingProductInfo";
import LogiTalkLandingInquiry from "./compnent/LogiTalkLandingInquiry";
import LogiTalkLandingAdvertiseVideoCenter from "./compnent/LogiTalkLandingAdvertiseVideoCenter";
import Footer from "../main/Footer";
import { useTranslation } from "react-i18next";

export default function LogiTalkLanding() {
  const { i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(i18n.language, () => {});
  }, []);
  return (
    <>
      <CommonNav />
      <main id="logitalk_landing">
        <LogiTalkLandingCarousel />
        <LogiTalkLandingProductInfo />
        <LogiTalkLandingInquiry />
        <LogiTalkLandingAdvertiseVideoCenter />
      </main>
      <Footer />
    </>
  );
}
